<template>
	<article class="card">
		<div v-if="title" class="card-header">
			<h2 v-if="title" class="card-title">
				{{ title }}
			</h2>
			<div v-if="typeof $slots.buttons !== 'undefined'" class="card-buttons">
				<slot name="buttons"></slot>
			</div>
		</div>

		<div class="card-body">
			<slot></slot>
		</div>
		<div v-if="typeof $slots.footer !== 'undefined'" class="card-footer">
			<slot name="footer"></slot>
		</div>
	</article>
</template>

<script setup lang="ts">
	defineProps({
		title: {
			type: String,
			default: null
		}
	});
</script>

<style scoped>
	.card {
		--card-padding-y: 16px;
		--card-padding-x: 12px;
		--card-border-radius: 0;

		background: #ffffff;
		border-radius: var(--card-border-radius);

		container-type: inline-size;
		container-name: card;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		align-items: center;
		padding: 8px var(--card-padding-x);
		border-bottom: 1px solid var(--color-grey-50);
		gap: var(--card-padding-x);
	}

	.card-title {
		flex: 0 1 auto;
		min-width: 0;
		font-size: 20px;
		line-height: 1;
		overflow-wrap: break-word;
		padding: 10px 0;
	}

	.card-buttons {
		flex: 0 0 auto;
		margin-left: auto;
	}

	.card-body,
	.card-footer {
		padding: var(--card-padding-y) var(--card-padding-x);
	}
</style>
